import { render, staticRenderFns } from "./TournamentsOffline.vue?vue&type=template&id=5e543254&scoped=true"
import script from "./TournamentsOffline.vue?vue&type=script&lang=js"
export * from "./TournamentsOffline.vue?vue&type=script&lang=js"
import style0 from "./TournamentsOffline.vue?vue&type=style&index=0&id=5e543254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e543254",
  null
  
)

export default component.exports